import React, { Component } from 'react';
import './index.scss';

import String from '../strings.json';

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {value: this.props.searchText};
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({value: event.target.value});
    sessionStorage.setItem('searchText',event.target.value);
  }
  clearSearch=()=>{
    this.setState({value: ''});
    sessionStorage.setItem('searchText','');
    document.getElementById("searchinput").focus();
  }
  handleEnter=(event)=>{
    event.preventDefault();
    this.props.searchConversationFunc(this.state.value);
  }

  render(){
    const { Question, Suggetion} = String.Conversation.Search;
    const {value}=this.state;
    const {searchConversationFunc,searchResult,typeofUser,showPaymntinfo} = this.props;
    const Placeholder = `Search for a ${typeofUser} or conversation by name or phone number`;
  return (
    <div className="search">
      {!searchResult?
      (<div>
      <div className="search_title">
        <span className="question">{Question}</span>
        <span className="suggestion">{Suggetion}</span>
      </div>
      <form className="search_input" onSubmit={this.handleEnter}>
        <input type="text" name="conversation" value={value} onChange={this.handleChange} className="search_input_box" placeholder={Placeholder} />
        {value && value.length===0? (<button className="search_input_submit" onClick={()=>searchConversationFunc(value)}><i className="material-icons">search</i></button>):
        (<button className="search_input_submit" onClick={()=>searchConversationFunc(value)}><i className="material-icons">close</i></button>)}
      </form>
      </div>):
      (
      <form className="search_input top-bar" onSubmit={this.handleEnter}>
        <input type="text" name="conversation" id="searchinput" value={value} onChange={this.handleChange} className="search_input_result" />
        <i className="material-icons" onClick={this.clearSearch}>close</i>
      </form>
      )
      }
    </div>
  );
  }
  
};

export default Search;
